// wrapped to help with testing, see import-meta-wrapper/__mocks__
// if this blows up in jest, add jest.mock(src/utils/import-meta-wrappers)
// we need to separate them out like this because of how our cypress setup uses string replacement

/**
 * wrapper to return import.meta.env.DEV
 *
 * @returns the DEV value
 */
export const getImportMetaEnvDev = () => import.meta.env.DEV;

/**
 * wrapper to return import.meta.env.VITE_PUBLIC_PATH
 *
 * @returns the VITE_PUBLIC_PATH value
 */
export const getImportMetaEnvVitePublicPath = () => import.meta.env.VITE_PUBLIC_PATH;
